<template>
    <div>
        <app-select
            label="Hintergrund- und Schriftfarbe"
            :data-source="'tecpage.user.modules.' + moduleId + '.appearance.color'"
            :options="getActiveModuleAppearanceColors"
            :data-default="{ type: 'random' }"
            :custom-class="'appearance-color'"
            hide-clear
            required
        ></app-select>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Select from '@/components/fields/simple/Select.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'getActiveModuleAppearanceColors'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R013'),
            help: this.$helpers.uiText('R014'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-select': Select
    }
};
</script>
